import { Component } from '@angular/core';

@Component({
  selector: 'app-platform-coverage',
  standalone: true,
  imports: [],
  templateUrl: './platform-coverage.component.html',
  styleUrl: './platform-coverage.component.scss'
})
export class PlatformCoverageComponent {

}
